
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getRequestPasswordResetDtoFormGroup() {
return new FormGroup({
    username: new FormControl<string | undefined>('', [Validators.required]),
})
;
}
      